module.exports = "<app-loading *ngIf=\"loading\"></app-loading>\r\n<div *ngIf=\"!loading\"></div>\r\n"